// extracted by mini-css-extract-plugin
export default {"bg-image":"Home_bg-image__qK2tI"};